"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const parseQuestionAnswer = (question, answer) => {
    const { type } = question;
    return types_1.StructuredQuestionTypes.includes(type)
        ? answer || {}
        : answer;
};
exports.default = parseQuestionAnswer;
